import { render, staticRenderFns } from "./SkeletalAnimation.vue?vue&type=template&id=42abbdfc&scoped=true&"
import script from "./SkeletalAnimation.vue?vue&type=script&lang=js&"
export * from "./SkeletalAnimation.vue?vue&type=script&lang=js&"
import style0 from "./SkeletalAnimation.vue?vue&type=style&index=0&id=42abbdfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42abbdfc",
  null
  
)

export default component.exports